import { MedicationStrength } from "~/common/types";

export const generateStrength = ({ amount, unit, form }: MedicationStrength) =>
  `${amount} ${unit} ${form}`;
